export default "__VITE_ASSET__777a76c1__"